import { render, staticRenderFns } from "./ApprovisionnementsGuichetNews.vue?vue&type=template&id=49ed261c&"
import script from "./ApprovisionnementsGuichetNews.vue?vue&type=script&lang=js&"
export * from "./ApprovisionnementsGuichetNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports